import { format } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { get } from '../../util/request'

const Info = () => {
    const [state, setState] = useState({
        infoList: '',
        startDate: format(new Date(), "yyyy-MM-dd"),
        dateForm: {
            startDate: '',
            endDate: '',
        },
				month: '',
				thisMonth: false,
        loading: true
    })

		const rawData = {
			monthList: [
				{ id: 1, name: 'January' },
				{ id: 2, name: 'February' },
				{ id: 3, name: 'March' },
				{ id: 4, name: 'April' },
				{ id: 5, name: 'May' },
				{ id: 6, name: 'June' },
				{ id: 7, name: 'July' },
				{ id: 8, name: 'August' },
				{ id: 9, name: 'September' },
				{ id: 10, name: 'October' },
				{ id: 11, name: 'November' },
				{ id: 12, name: 'December' },
			]
		};

    const jwtToken = useSelector(state => state.auth.generateToken)
    const user = useSelector(state => state.auth.user)

    useEffect(() => {
        let isMounted = true
        if (isMounted) {
					var url = `public/api/v1/info-list?companyId=${user.company_id}&date=${state.startDate}`

					if (state.thisMonth) {
						url = `public/api/v1/info-list?companyId=${user.company_id}&month=${state.month}&thisMonth=true`

					} else if (state.month) {
						url = `public/api/v1/info-list?companyId=${user.company_id}&month=${state.month}`
					} 

            getInfoList(url)
        }
        return () => isMounted === false
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.month])

    const getInfoList = (url) => {
        get(
            url,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    'Content-Type': 'application/json'
                },
            },
            success => {
                setState(prevState => {
                    return {
                        ...prevState,
                        // tasksList: success.data.Data,
                        infoList: success.data.Data,
                        loading: false
                    }
                })
            },
            error => {
                setState(prevState => {
                    return {
                        ...prevState,
                        loading: false
                    }
                })
                console.log('error request', error)
            }
        )
    }

		const handleSelectedMonth = (e) => {
			var thisMonths = state.thisMonth
			var date = new Date()

			if(e.target.value === date.getMonth() || e.target.value === 'thisMonth' ){
				thisMonths= true
			}
			else {
				thisMonths = false
			}

			setState(prevState => {
				return {
					...prevState,
					month: e.target.value,
					thisMonth: thisMonths
				}
			})
		}

	return (
		state.loading ? " " :
		<div className='w-full h-screen grid-cols-1 sm:grid-cols-2 bg-bg-primary'>
			<div className='w-full h-20 bg-real-white'>
				<div className='flex items-center h-full px-4'>
					<a href={process.env.PUBLIC_URL + "/home"}>
						<img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
					</a>
					<p className='px-4'>Info & Berita</p>
				</div>
			</div>
			<div className='w-full'>
				<div className='w-2/3 h-full mx-4 mt-4'>
					<select id="countries" onChange={(e) => handleSelectedMonth(e)} value={state.month} className="bg-real-white border border-white text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:focus:ring-blue-500 dark:focus:border-blue-500">
						<option value='thisMonth'>This Month</option>
						{rawData.monthList.map((item, index) => (
							<option key={index} value={item.id}>{item.name}</option>
						))}
					</select>

				</div>
				<div className='grid grid-cols-1'>

					<div className="w-full px-4 mt-6 ">
						{state.infoList?.map((item,index) => (
							<a href={process.env.PUBLIC_URL + "/info/" + item.info_id} key={index} className="block h-full text-black rounded-lg shadow-all bg-real-white">
							<div className='grid h-full grid-cols-4 place-items-center'>
								<div className='w-full h-full bg-blue-200 rounded-l-lg ' style={{ backgroundImage: `url(${item.image_url})`, backgroundSize: 'cover' }}>
								</div>
								<div className='flex flex-col w-full col-span-3 p-4 text-left place-items-start'>
									<p className='text-base font-bold text-red-bg'>{item.title}</p>
									<p className='pt-4 text-xs text-grey-dark'>{item.sub_title}</p>
									{/* <p className='text-xs text-grey-dark'>14:30 WIB</p>
									<p className='text-xs text-grey-dark'>12 September 2021</p> */}
								</div>
							</div>
						</a>
						))}
						
					</div>

				</div>
			</div>




		</div >
	)
}

export default Info